import type { IntakeStep } from "../types";

export type IntakePartDefinition = {
  id: "basics" | "offering" | "operations";
  label: string;
  title: string;
  description: string;
  stepIds: string[];
};

// 파트너 화면은 step 10개를 3개 파트로 묶어 보여준다. step id/rule 체계는 그대로 유지된다.
export const INTAKE_PARTS: IntakePartDefinition[] = [
  {
    id: "basics",
    label: "1",
    title: "업체·예약 정보",
    description: "업체 기본 정보와 예약 받는 방식을 알려주세요.",
    stepIds: ["welcome", "company", "reservation", "contract"],
  },
  {
    id: "offering",
    label: "2",
    title: "상품과 소개",
    description: "판매할 상품 구성과 우리 업체의 장점을 알려주세요.",
    stepIds: ["products", "content", "doctors"],
  },
  {
    id: "operations",
    label: "3",
    title: "안내사항·자료 제출",
    description: "고객 안내 정책을 확인하고 사진과 서류를 첨부한 뒤 제출해요.",
    stepIds: ["policy", "photos", "documents", "review"],
  },
];

export function getIntakePartForStepId(stepId: string): IntakePartDefinition | null {
  return INTAKE_PARTS.find((part) => part.stepIds.includes(stepId)) ?? null;
}

export function getPartIndexForStepId(stepId: string): number {
  const index = INTAKE_PARTS.findIndex((part) => part.stepIds.includes(stepId));
  return index >= 0 ? index : 0;
}

export function groupIntakeItemsByPart<T>(items: T[], getStepId: (item: T) => string): Array<{ part: IntakePartDefinition; items: T[] }> {
  return INTAKE_PARTS.map((part) => ({
    part,
    items: items.filter((item) => part.stepIds.includes(getStepId(item))),
  }));
}

export function getPartSteps(steps: IntakeStep[], partIndex: number): IntakeStep[] {
  const part = INTAKE_PARTS[partIndex];
  if (!part) return [];
  return steps.filter((step) => part.stepIds.includes(step.id));
}

export function getFirstStepIndexOfPart(steps: IntakeStep[], partIndex: number): number {
  const part = INTAKE_PARTS[partIndex];
  if (!part) return 0;
  const index = steps.findIndex((step) => part.stepIds.includes(step.id));
  return index >= 0 ? index : 0;
}
